import styled from "styled-components";

// Container interno do modal (dentro de ModalBody)
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  /* ========== TABS HEADER ========== */
  .tabs-header {
    display: flex;
    gap: 8px;

    .tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 14px;
      background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.04)'};
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 10px;
      color: ${({ theme }) => theme.text};
      opacity: 0.6;
      font-size: 0.8em;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        opacity: 1;
        border-color: rgba(16, 185, 129, 0.3);
      }

      &.active {
        opacity: 1;
        background: rgba(16, 185, 129, 0.1);
        border-color: rgba(16, 185, 129, 0.3);
        color: #10b981;

        .tab-count {
          background: rgba(16, 185, 129, 0.2);
          color: #10b981;
        }
      }

      &.warning:not(.active) {
        border-color: rgba(245, 158, 11, 0.4);
        color: #f59e0b;
        opacity: 0.8;

        .tab-count {
          background: rgba(245, 158, 11, 0.15);
          color: #f59e0b;
        }
      }

      svg { font-size: 0.9em; }

      .tab-count {
        background: ${({ theme }) => theme.border};
        padding: 2px 7px;
        border-radius: 10px;
        font-size: 0.8em;
        font-weight: 600;
      }
    }
  }

  /* ========== WARNING BANNER ========== */
  .warning-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: rgba(245, 158, 11, 0.06);
    border: 1px solid rgba(245, 158, 11, 0.2);
    border-radius: 10px;
    color: #f59e0b;
    font-size: 0.82em;

    svg { flex-shrink: 0; font-size: 1.1em; }

    span {
      flex: 1;
      color: ${({ theme }) => theme.text};
      opacity: 0.8;

      strong { color: #f59e0b; }

      button {
        background: none;
        border: none;
        color: #f59e0b;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 500;
        margin-left: 8px;
        padding: 0;
        font-size: 1em;

        &:hover { color: #d97706; }
      }
    }
  }
`;

// Header removido — agora usa ModalHeader do ModalShared
export const Header = styled.div``;

export const KPIGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @media (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const KPICard = styled.div`
  background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.03)'};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(16, 185, 129, 0.2);
  }

  &.nfe { .thumb { color: #f59e0b; } }
  &.cte { .thumb { color: #8b5cf6; } }
  &.nfce { .thumb { color: #3b82f6; } }
  &.itens { .thumb { color: #10b981; } }
  &.empresas { .thumb { color: ${({ theme }) => theme.text}; } }

  .card-content {
    display: flex;
    align-items: center;
    gap: 12px;

    .thumb {
      opacity: 0.6;
      font-size: 1em;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .text {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .value {
        font-size: 1.1em;
        font-weight: 700;
        color: ${({ theme }) => theme.text};
        letter-spacing: -0.02em;
        line-height: 1.1;
      }

      .label {
        font-size: 0.72em;
        color: ${({ theme }) => theme.text};
        opacity: 0.5;
        font-weight: 500;
        margin: 0;
      }
    }
  }
`;

export const FileTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 2px;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: ${({ theme }) => theme.border}; border-radius: 2px; }

  .table-header {
    display: none;
  }

  .table-body {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 32px 16px;
      color: ${({ theme }) => theme.text};
      opacity: 0.35;
      text-align: center;

      svg { margin-bottom: 8px; opacity: 0.4; }
      p { margin: 0 0 4px 0; font-weight: 500; font-size: 0.82em; }
      small { font-size: 0.75em; opacity: 0.7; }
    }

    .table-row {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 10px 14px;
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 10px;
      background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.01)' : 'rgba(255,255,255,0.02)'};
      color: ${({ theme }) => theme.text};
      transition: all 0.15s;

      &:hover { border-color: rgba(16, 185, 129, 0.2); }

      &.warning-row {
        border-color: rgba(245, 158, 11, 0.3);
        background: rgba(245, 158, 11, 0.02);
      }

      .cell {
        display: flex;
        flex-direction: column;
        gap: 1px;
        
        strong { 
          font-weight: 600; 
          font-size: 0.82em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        small { 
          opacity: 0.45; 
          font-size: 0.72em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .cnpj-mismatch {
          color: #f59e0b;
          font-size: 0.72em;
          opacity: 1;
        }
      }

      .row-stats {
        display: flex;
        gap: 12px;
        font-size: 0.72em;
        opacity: 0.5;
      }

      .status-badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 8px;
        border-radius: 6px;
        font-size: 0.72em;
        font-weight: 500;
        width: fit-content;
        
        &.valid { background: rgba(16, 185, 129, 0.1); color: #10b981; }
        &.invalid { background: rgba(239, 68, 68, 0.1); color: #ef4444; }
        &.warning { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }
      }
    }
  }
`;

// Button mantido para compatibilidade (usa ModalButton do ModalShared preferencialmente)
export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  border-radius: 10px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  &.primary {
    background: #10b981;
    color: white;
    &:hover:not(:disabled) { background: #059669; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  &.secondary {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.text};
    opacity: 0.7;
    &:hover { opacity: 1; border-color: ${({ theme }) => theme.text}; }
  }
`;
